import config from '@medflex/utils/config';
import _ from 'lodash/fp';
import { BookmarkTypes } from '@medflex/shared-types';
import makeApiRequest from '../../../api/makeApiRequest';

const Bookmarks = {
  name: 'bookmarks',
  state: {
    bookmarks: [],
  },
  reducers: {
    onUpdated: (state, bookmarks) => {
      return {
        ...state,
        bookmarks: state.bookmarks.map(b => {
          const newBookmark = bookmarks.find(({ id }) => id === b.id);
          return newBookmark
            ? {
                ...b,
                attributes: {
                  ...b.attributes,
                  ...newBookmark.attributes,
                },
              }
            : b;
        }),
      };
    },
    onLoaded: (state, bookmarks) => {
      return {
        ...state,
        bookmarks: _.uniqBy('id', [...bookmarks, ...state.bookmarks]),
      };
    },
    onCreated(state, bookmarks) {
      return {
        ...state,
        bookmarks: [...state.bookmarks, ...bookmarks],
      };
    },
  },
  effects: dispatch => ({
    async load(filter, { oidcSession }) {
      const url = new URL(`${config.PROFILE_SERVICE_ENDPOINT}/bookmarks`);
      url.search = new URLSearchParams(filter);
      const [request] = makeApiRequest({ url, method: 'get' }, oidcSession);
      const { error, data } = await request;
      if (error) {
        dispatch.errors.add({ realm: 'bookmarks', type: 'load', error });
        return;
      }
      if (data) {
        this.onLoaded(data.data);
      }
    },
    async create(payload, { oidcSession }) {
      const [request] = makeApiRequest(
        { url: `${config.PROFILE_SERVICE_ENDPOINT}/bookmarks`, method: 'post', data: payload },
        oidcSession,
      );
      const { error, data } = await request;
      if (error) {
        dispatch.errors.add({ realm: 'bookmarks', type: 'create', error });
      }
      if (data) {
        this.onCreated(data.data);
      }
    },
  }),
  selectors: slice => ({
    byType() {
      return slice(({ bookmarks }) =>
        _.flow(
          _.sortBy(({ attributes }) => _.toLower(attributes.name)),
          _.groupBy('attributes.kind'),
          rs => ({
            ...rs,
            ...(rs[BookmarkTypes.PRESCRIPTIONS]
              ? {
                  [BookmarkTypes.PRESCRIPTIONS]: _.groupBy('attributes.practitionerId')(
                    rs[BookmarkTypes.PRESCRIPTIONS],
                  ),
                }
              : {}),
          }),
        )(bookmarks),
      );
    },
  }),
};

export default Bookmarks;
